export type TAction<Type> = {
  type: Type;
}

export type TPauseItem = {
  value: number;
  text: string | number
}

export interface IGoogleAnalytic {
  push: (data: any[]) => void;
}

export const EMPTY_ARRAY: any[] = [];
